import React, { useCallback } from 'react';
import { Styles } from './styles';
import { MobileFooter } from './Mobile/MobileFooter';
import { DesktopFooter } from './Desktop/DesktopFooter';
import { useRouter } from 'next/router';
import { CustomEventName, logTrackingEvent } from 'services/analytics';
import { ATTRIBUTION_LINKS } from 'constants/paths';

const productDBAttributionLink =
  process.env.ENVIRONMENT === 'production'
    ? ATTRIBUTION_LINKS.productDB.prod
    : ATTRIBUTION_LINKS.productDB.staging;

export const ProductFooter = () => {
  const { push } = useRouter();
  const navigateToOnBoarding = useCallback(() => {
    logTrackingEvent({ name: CustomEventName.Product_Footer_Sign_Up });
    push(productDBAttributionLink);
  }, [push]);
  return (
    <>
      <Styles.Mobile>
        <MobileFooter onClick={navigateToOnBoarding} />
      </Styles.Mobile>
      <Styles.Desktop>
        <DesktopFooter onClick={navigateToOnBoarding} />
      </Styles.Desktop>
    </>
  );
};
